import themeColors from "./colors";

export const chartColors = {
    fii: {
        line: {
            lineStroke: themeColors.GREEN,
            bulletColor: '#000',
            bulletStroke: themeColors.GREEN,
            tooltipBg: themeColors.GREEN,
            tooltipColor: '#000',
            diagonalDates: true,
            textColor: themeColors.NAVY,
            boldText: true,
            showGrid: true,
            yGridColor: '#337dab',
            bulletRadius: 4,
            axisColor: '#407597'
        },
        sentiments: {
            showYAxis: false,
            boldText: true,
            colorizeLabels: true,
            positiveLabelBorder: true,
            yGridColor: '#337dab',
        },
        top10: {
            iconColor: themeColors.FII_BAR_CHART,
            labelColor: themeColors.FII_BAR_CHART,
            labelFontWeight: '500',
        },
        table: {
            header: {
                color: themeColors.FII_BAR_CHART,
            },
            data: {
                color: themeColors.FII_BAR_CHART,
            },
            iconColor: themeColors.FII_BAR_CHART,
            showGridLines: false,
        },
        pie: {
            colorArray: [
                themeColors.CHROME_YELLOW,
                themeColors.BLUE_SAPPHIRE,
                themeColors.DARK_CYAN,
                themeColors.PACIFIC_BLUE,
                themeColors.SPRING_GREEN,
                themeColors.KEY_LIME,
                themeColors.SPACE_CADET,
                themeColors.AQUA,
                themeColors.BLUE_CRAYOLA,
                themeColors.LAVENDER,
                themeColors.ULTRA_RED,
            ]
        },
        map: {
            color: themeColors.FII_BAR_CHART
        }
    },
    expo: {
        line: {
            lineStroke: themeColors.CYAN,
            bulletColor: '#000',
            bulletStroke: themeColors.CYAN,
            tooltipBg: themeColors.CYAN,
            tooltipColor: '#000',
            diagonalDates: false,
            textColor: themeColors.LIGHT_GREY,
            boldText: false,
            showGrid: false,
            bulletRadius: 3,
            axisColor: '#595959'
        },
        sentiments: {
            showYAxis: true,
            boldText: true,
            colorizeLabels: false,
            positiveLabelBorder: false,
        },
        top10: {
            iconColor: themeColors.EXPO_BAR_CHART,
            boldHeaders: true
        },
        table :{
            header: {
                color: themeColors.PURPLE,
            },
            data: {
                color: themeColors.PURPLE,
            },
            iconColor: themeColors.PURPLE,
            showGridLines: false,
        },
        map: {},
        pie: {
            colorArray: []
        }
    }
}